import BibliographyAloneSearch, {
  InputAloneSearchItem,
  defaultInputAloneSearchItem
} from './BibliographyAloneSearch.vue'

export {
  BibliographyAloneSearch,
  InputAloneSearchItem,
  defaultInputAloneSearchItem
}
